import fetch from 'isomorphic-fetch'
import {browserHistory} from 'react-router'
import {pendingTask, begin, end} from 'react-redux-spinner'
const moment = require('moment-timezone')
import {
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT,
  UPDATE_EVENT_ERROR,
  GET_EVENT_REQUEST_LOAD,
  GET_EVENT_REQUEST_LOAD_SUCCESS,
  GET_EVENT_REQUEST,
  GET_EVENT,
  GET_EVENT_ERROR,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT,
  DELETE_EVENT_ERROR,
} from './types'

export function updateEventRequest() {
  const data = {
    loading: true,
  }
  return {
    type: UPDATE_EVENT_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function updateEventSuccess(event) {
  const data = {
    loading: false,
    event,
  }
  return {
    type: UPDATE_EVENT,
    [pendingTask]: end,
    payload: data,
  }
}

export function updateEventFail(error) {
  const data = {
    loading: false,
    error,
  }
  return {
    type: UPDATE_EVENT_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function updateEvent(event) {
  return dispatch => {
    dispatch(updateEventRequest())
    //console.warn('startTime: ' + event.startTime)
    //let offset = moment().utcOffset()
    let startTime = moment(event.startTime)
    event.startTime = startTime
    let endTime = moment(event.endTime)
    event.endTime = endTime
    //console.warn('st: ' + startTime.utc().format())
    // console.warn('moment startTime: ' + startTime.utcOffset(offset).toDate())
    // console.warn('moment startTime: ' + startTime.utcOffset(offset).format())
    // console.warn(
    //   'moment startTime: ' + startTime.utcOffset(offset).toISOString(),
    // )

    return fetch(`${process.env.REACT_APP_EF_API_URL}/event/${event.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
      body: JSON.stringify(event),
    })
      .then(res => res.json())
      .then(json => {
        dispatch(updateEventSuccess(json.event))
        browserHistory.push(`/events/${event.id}`)
      })
      .catch(error => dispatch(updateEventFail(error)))
  }
}

export function getEventRequestLoad() {
  const data = {
    loading: true,
  }
  return {
    type: GET_EVENT_REQUEST_LOAD,
    [pendingTask]: begin,
    payload: data,
  }
}

export function getEventRequestLoadSuccess() {
  const data = {
    loading: false,
  }
  return {
    type: GET_EVENT_REQUEST_LOAD_SUCCESS,
    [pendingTask]: end,
    payload: data,
  }
}

export function getEventRequest() {
  const data = {
    loading: true,
  }
  console.error('EVENT REQUESTED....' + data.loading)
  return {
    type: GET_EVENT_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function getEventSuccess(event) {
  console.log('get event success ' + JSON.stringify(event))
  const data = {
    loading: false,
    event,
  }
  return {
    type: GET_EVENT,
    [pendingTask]: end,
    payload: data,
  }
}

export function getEventFail(error) {
  const data = {
    loading: false,
    error,
  }
  return {
    type: GET_EVENT_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function getEventLoad() {
  return dispatch => {
    dispatch(getEventRequestLoad())
  }
}

export function getEventLoadSuccess() {
  return dispatch => {
    dispatch(getEventRequestLoadSuccess())
  }
}

export function getEvent(id) {
  return dispatch => {
    dispatch(getEventRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/event/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    })
      .then(res => res.json())
      .then(json => {
        dispatch(getEventSuccess(json.event))
      })
      .catch(error => dispatch(getEventFail(error)))
  }
}

export function deleteEventRequest() {
  console.log('requesting event delete')
  const data = {
    loading: true,
  }
  return {
    type: DELETE_EVENT_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function deleteEventSuccess(event) {
  console.log('delete event sucess: ' + event)
  const data = {
    loading: false,
    event,
  }
  return {
    type: DELETE_EVENT,
    [pendingTask]: end,
    payload: data,
  }
}

export function deleteEventFail(error) {
  console.log('event delete error : ' + error)
  const data = {
    loading: false,
    error,
  }
  return {
    type: DELETE_EVENT_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function deleteEvent(event) {
  return dispatch => {
    dispatch(deleteEventRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/event/${event}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
        body: JSON.stringify(event),
      },
    })
      .then(res => res.json())
      .then(json => {
        dispatch(deleteEventSuccess(json.event))
        browserHistory.push('/events/')
      })
      .catch(error => dispatch(deleteEventFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/event_edit.js
 **/